<!-- 分账弹框 -->

<template>
  <a-modal v-model:visible="visible" :title="title" :maskClosable="false" width="800px">
    <div style="font-size: 18px; font-weight: bold">
      支付宝分账功能已上线，需要您点击【查看分账状态】确认分账产品授权成功，如授权未成功，则部分功能将受到支付宝限制
    </div>
    <template #footer>
      <div class="footer_home">
        <div class="footer_left">
          <a-button key="back" @click="handleCancel">关闭</a-button>
        </div>
        <div class="footer_right">
          <a-popover trigger="hover" placement="bottom">
            <template #content>
              <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 0.6em">
                <a-tag color="red" style="font-size: 15px">微信扫一扫联系客服</a-tag>
              </div>
              <div>
                <img src="~@/assets/kefu.jpg" width="300" height="300" />
              </div>
            </template>
            <a-button type="primary"> 联系客服 </a-button>
          </a-popover>
          <a-button
            key="submit"
            type="primary"
            :loading="loading"
            @click="gotoUrl('https://b.alipay.com/page/product-workspace/product-detail/I1080300001000043489')"
            >查看分账状态</a-button
          >
          <a-button key="submit" type="primary" :loading="loading" @click="gotoUrl('https://b.alipay.com/page/home')"
            >前往支付宝后台</a-button
          >
        </div>
      </div>
    </template>
  </a-modal>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      title: "温馨提示",
      visible: false,
    };
  },
  methods: {
    //入口
    open() {
      this.visible = true;
    },
    //前往地址
    gotoUrl(url) {
      window.open(url);
    },
    //关闭方法
    handleCancel() {
      this.visible = false;
    },
  },
  mounted() {},
};
</script>

<style scoped lang="less">
.footer_home {
  display: flex;
  justify-content: space-between;
}
</style>
